import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import hourCountDown from '../../assets/img/hour_coundown.png'
import minCountDown from '../../assets/img/minute_countdown.png'
import { diffHours, diffMinutes, diffSeconds } from '../../common/utils';
import { useTranslation } from "react-i18next";

const PlayCountdown = ({ termInfo }) => {
    const [hour, setHour] = React.useState(0);
    const [min, setMin] = React.useState(0);
    const [sec, setSec] = React.useState(0);
    const { t } = useTranslation();


    // getTime();
    useEffect(() => {
        getTime();
    }, []);


    function getTime() {
        // calculator time left

        let dateConvert = Date.parse(termInfo.dateRun + "T" + termInfo.fromTime);
        // console.log("dateConvert: " + dateConvert);
        // console.log("date now: " + Date.now());

        let hours = diffHours(dateConvert, Date.now());
        let mins = diffMinutes(dateConvert, Date.now()) - hours * 60;
        let secs = diffSeconds(dateConvert, Date.now()) - hours * 60 * 60 - mins * 60;

        setHour(hours);
        setMin(mins);
        setSec(secs);

        setTimeout(() => {
            getTime();
        }, 1000)
    }

    return (
        <div>
            <div className='frame-time-container'>
                <div className='frame-time-box'>
                    {t("frameTime").toUpperCase()}
                </div>

                <div className='frame-time-detail'>
                    <div className='frame-time-day'>
                        {termInfo.dateRun}
                    </div>
                    <div className='frame-time-day'>
                        {termInfo.fromTime} - {termInfo.toTime}
                    </div>
                </div>
            </div>

            <div className='play-countdown-title'>
            {t("auctionComenceIn").toUpperCase()}
            </div>
            <div className='play-countdown-container'>
                {
                    (() => {
                        if (hour <= 0 && min <= 0 && sec <= 0) {
                            return <div className='play-countdown-title' style={{ fontSize: "12px" }}>
                                Waiting ...
                            </div>
                        } else {
                            return <div className="row">
                                <div className="col-4 countdown-box countdown-box-1">
                                    <img src={hourCountDown} />
                                    <div className='countdown-number'>
                                        {hour < 10 ? "0" + hour : hour}
                                    </div>
                                    <div className='countdown-title'>
                                        {hour < 2 ? t("hours").toUpperCase() : t("hours").toUpperCase()}
                                    </div>
                                </div>
                                <div className="col-4 countdown-box countdown-box-2">
                                    <img src={minCountDown} />
                                    <div className='countdown-number'>
                                        {min < 10 ? "0" + min : min}
                                    </div>
                                    <div className='countdown-title'>
                                        {min < 2 ? t("minutes").toUpperCase() : t("minutes").toUpperCase()}
                                    </div>
                                </div>
                                <div className="col-4 countdown-box countdown-box-2">
                                    <img src={minCountDown} />
                                    <div className='countdown-number'>
                                        {sec < 10 ? "0" + sec : sec}
                                    </div>
                                    <div className='countdown-title'>
                                        {sec < 2 ? t("seconds").toUpperCase() : t("seconds").toUpperCase()}
                                    </div>
                                </div>
                            </div>
                        }
                    })()
                }
            </div>
            <div className='play-countdown-title' style={{ fontSize: "12px" }}>
                {t("previousFrameUpdatedAfter10Min").toUpperCase()}
            </div>
        </div>
    );
}

export default PlayCountdown;